module.exports = __webpack_public_path__ + "img/ipad.eab45d0a.svg";